module.exports = __webpack_public_path__ + "static/media/sticky-note.e3954e63.svg";